/**
 * Service: authService
 * 
 * Centralized auth API calls for Supabase
 * All auth-related Supabase operations go here
 */

import { supabase } from '../supabaseClient'

export const authService = {
  /**
   * Get current session
   */
  async getSession() {
    return supabase.auth.getSession()
  },

  /**
   * Subscribe to auth state changes
   * @param {Function} callback - Called with (event, session)
   * @returns {Object} Subscription object with unsubscribe method
   */
  onAuthStateChange(callback) {
    return supabase.auth.onAuthStateChange(callback)
  },

  /**
   * Sign in with email and password
   */
  async signIn(email, password) {
    return supabase.auth.signInWithPassword({
      email,
      password
    })
  },

  /**
   * Send password reset email
   */
  async resetPasswordForEmail(email, redirectTo) {
    return supabase.auth.resetPasswordForEmail(email, {
      redirectTo
    })
  },

  /**
   * Update user password (must have active session)
   */
  async updatePassword(newPassword) {
    return supabase.auth.updateUser({ password: newPassword })
  },

  /**
   * Sign out current user
   */
  async signOut() {
    return supabase.auth.signOut()
  }
}
